/*
 * Autocomplete - rewritten to JS by USIT and made accessible with ARIA
 *
 * Based on Autocomplete jQuery plugin 1.0.2 (and modified heavily by USIT, see bottom of file for original change list)
 *
 * Copyright (c) 2007 Dylan Verheul, Dan G. Switzer, Anjesh Tuladhar, Jörn Zaefferer
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 *
 * Revision: $Id: jquery.autocomplete.js 5747 2008-06-25 18:30:55Z joern.zaefferer $
 *
 */

// TODO: load library from here instead of embedded in autocomplete-custom.js
//       for utveksling/IT-tjenester custom autocomplete search (based on data instead URL)

class Autocomplete {
  constructor(id, urlOrData, options) {
    const isUrl = typeof urlOrData == "string";

    const defaults = {
      // Data input is either API URL with dynamic autocomplete query or JSON-data directly
      url: isUrl ? urlOrData : null, // API URL
      data: isUrl ? null : urlOrData, // JSON-data directly

      delay: isUrl ? 200 : 10, // To not overload backend with fetch() / ajax requests (no delay if JSON-data directly)
      inputClass: "ac_input",
      resultsClass: "ac_results",
      loadingClass: "ac_loading",
      minChars: 1, // minimum chars before autocomplete
      matchCase: false, // if should differentiate between uppercase/lowercase
      matchSubset: false,
      matchContains: false,
      cacheLength: 10,
      max: options && !options.scroll ? 10 : 150,
      extraParams: {}, // extra fetch() (ajax call) params
      selectFirst: true, // if should select first on autocomplete results
      formatItem: function(row) {
        return row[0];
      },
      formatMatch: null,
      autoFill: false, // should probably always be set to false
      width: 0,
      minWidth: null,
      adjustLeft: 0,
      multiple: false, // probably not working, not sure (it is never used on UiO)
      multipleSeparator: ", ",
      highlight: function(value, term) {
        return value.replace(new RegExp("^(?![^&;]+;)(?!<[^<>]*)("
            + term.replace(/([\^\$\(\)\[\]\{\}\*\.\+\?\|\\])/gi, "\\$1") + ")(?![^<>]*>)(?![^&;]+;)", "gi"),
            "<strong>$1</strong>");
      },
      scroll: true,
      resultsBeforeScroll: 10, // don't show scrollbar if <= than this
      scrollHeight: 180, // otherwise this is the height of scrollable autocomplete result
      adjustForParentWidth: null,
      finiteScroll: true, // whether it should be possible to scroll inifinie (from end to start and other way)
      updateInput: true
    };
    options = Object.assign({}, defaults, options);

    // if highlight is set to false, replace it with a do-nothing function
    options.highlight = options.highlight || function(value) {
      return value;
    };

    // if the formatMatch option is not specified, then use formatItem for
    // backwards compatibility
    options.formatMatch = options.formatMatch || options.formatItem;

    this.setup(document.getElementById(id), options);
  }

  setup(input, options) {  
    const autocompleteCourseFieldAttributes = {
      "autocomplete": "off",
      "aria-autocomplete": "both",
      "role": "combobox",
      "aria-owns": "ac_results-" + options.typeString,
      "aria-controls": "ac_results-" + options.typeString,
      "autocorrect": "off",
      "aria-expanded": "false"
    };
    setAttributes(input, autocompleteCourseFieldAttributes);
  
    input.classList.add(options.inputClass);
  
    var timeout;
    var previousValue = "";
    var cache = this.AutocompleteCache(options);
    var hasFocus = 0;
    var lastKeyPressCode;
    var config = {
      mouseDownOnSelect :false
    };
    var select = this.AutocompleteSelect(options, input, selectCurrent, config);
  
    input.addEventListener("keydown", (e) => {
      // track last key pressed
      lastKeyPressCode = e.key;
      switch (e.key) {
  
        case "ArrowUp":
          e.preventDefault();
          if (select.visible()) {
            select.prev();
          } else {
            onChange(true);
          }
          break;
  
        case "ArrowDown":
          e.preventDefault();
          if (select.visible()) {
            select.next();
          } else {
            onChange(true);
          }
          break;
        case "PageUp":
          e.preventDefault();
          if (select.visible()) {
            select.pageUp();
          } else {
            onChange(true);
          }
          break;
  
        case "PageDown":
          e.preventDefault();
          if (select.visible()) {
            select.pageDown();
          } else {
            onChange(true);
          }
          break;
  
        case "ArrowRight":
        case "Enter":
          if (selectCurrent()) {
            // stop default to prevent a form submit, Opera needs special
            // handling
            e.preventDefault();
            return false;
          }
          break;
  
        case "Escape":
          select.hide();
          break;
  
        default:
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            onChange();
          }, options.delay);
          break;
      }
    });
    input.addEventListener("focus", (e) => {
      // track whether the field has focus, we shouldn't process any
      // results if the field no longer has focus
      hasFocus++;
    });
    input.addEventListener("blur", (e) => {
      hasFocus = 0;
      if (!config.mouseDownOnSelect) {
        hideResults();
      }
    });
    input.addEventListener("click", (e) => {
      // show select when clicking in a focused field
      if (hasFocus++ > 1 && !select.visible()) {
        onChange(true);
      }
    });
  
    function setAttributes(elm, attrs) {
      Object.keys(attrs).forEach(key => elm.setAttribute(key, attrs[key]));
    }
  
    function selectCurrent() {
      var selected = select.selected();
      if (!selected)
        return false;
  
      var v = selected.result;
      previousValue = v;
  
      if(options.updateInput) {
        if (options.multiple) {
          var words = trimWords(input.value);
          if (words.length > 1) {
            v = words.slice(0, words.length - 1).join(options.multipleSeparator) + options.multipleSeparator + v;
          }
          v += options.multipleSeparator;
        }
        input.value = v;
      }
  
      hideResultsNow()
      input.dispatchEvent(new CustomEvent("result", { "detail": 
        { 
          "data": selected.data,
          "formatted": selected.value
        }
      }));
      return true;
    }
  
    function onChange(skipPrevCheck) {
      if (lastKeyPressCode == "Delete") {
        select.hide();
        return;
      }
  
      var currentValue = input.value;
  
      if (!skipPrevCheck && currentValue == previousValue)
        return;
  
      var delimiter = options.multipleSeparator.trim();
      currentValue = currentValue.trim();
      if (currentValue.match(delimiter + "$") == delimiter) {
        stopLoading();
        select.hide();
        return;
      }
  
      previousValue = currentValue;
  
      currentValue = lastWord(currentValue);
      if (currentValue.length >= options.minChars) {
        input.classList.add(options.loadingClass);
        input.setAttribute("aria-busy", "true");
        if (!options.matchCase)
          currentValue = currentValue.toLowerCase();
        request(currentValue, receiveData, hideResultsNow);
      } else {
        stopLoading();
        select.hide();
      }
    }
  
    function trimWords(value) {
      if (!value) {
        return [ "" ];
      }
      var words = value.split(options.multipleSeparator);
      var result = [];
      words.forEach((value, i) => {
        result[i] = value.trim();
      });
  
      return result;
    }
  
    function lastWord(value) {
      if (!options.multiple)
        return value;
      var words = trimWords(value);
      return words[words.length - 1];
    }
  
    function selection(field, start, end) {
      if (field.createTextRange) {
        var selRange = field.createTextRange();
        selRange.collapse(true);
        selRange.moveStart("character", start);
        selRange.moveEnd("character", end);
        selRange.select();
      } else if (field.setSelectionRange) {
        field.setSelectionRange(start, end);
      } else {
        if (field.selectionStart) {
          field.selectionStart = start;
          field.selectionEnd = end;
        }
      }
      field.focus();
    }
  
    // fills in the input box w/the first match (assumed to be the best match)
    // q: the term entered
    // sValue: the first matching result
    function autoFill(q, sValue) {
      // autofill in the complete box w/the first match as long as the user
      // hasn't entered in more data
      // if the last user key pressed was backspace, don't autofill
      if (options.autoFill && (lastWord(input.value).toLowerCase() == q.toLowerCase())
          && lastKeyPressCode != "Backspace") {
        // fill in the value (keep the case the user has typed)
        input.value = input.value + sValue.substring(lastWord(previousValue).length);
        // select the portion of the value not typed by the user (so the next
        // character will erase)
        selection(input, previousValue.length, previousValue.length + sValue.length);
      }
    }
  
    function hideResults() {
      clearTimeout(timeout);
      timeout = setTimeout(hideResultsNow, 200);
    }
  
    function hideResultsNow() {
      var wasVisible = select.visible();
      select.hide();
      clearTimeout(timeout);
      stopLoading();
  
      if (wasVisible)
        // position cursor at end of input field
        selection(input, input.value.length, input.value.length);
    }
  
    function receiveData(q, data) {
      if (data && data.length && hasFocus) {
        stopLoading();
        select.display(data, q);
        autoFill(q, data[0].value);
        select.show();
      } else {
        hideResultsNow();
      }
    }
  
    function request(term, success, failure) {
      if (!options.matchCase)
        term = term.toLowerCase();
      var data = cache.load(term);
      // recieve the cached data
      if (data && data.length) {
        success(term, data);
        // if an AJAX url has been supplied, try loading the data now
      } else if ((typeof options.url == "string") && (options.url.length > 0)) {
  
        var extraParams = {
          timestamp :+new Date()
        };
        for (const [key, param] of Object.entries(options.extraParams)) {
          extraParams[key] = typeof param == "function" ? param() : param;
        }
  
        const reqData = Object.assign({}, {
          q: options.termFormat ? options.termFormat.replace("%term%", lastWord(term)) : lastWord(term),
          limit: options.max
        }, extraParams);

        if(options.autocompleteTemplate) {
          reqData.t = options.autocompleteTemplate;
        }
  
        // TODO: options.dataType was sent to $.ajax, but doesn't look like it's used anywhere
        fetch(options.url + "&" + new URLSearchParams(reqData).toString()).then((response) => {
          return response.text();
        }).then((data) => {
          var parsed = options.parse && options.parse(data) || parse(data);
          cache.add(term, parsed);
          success(term, parsed);
        }).catch((error) => {
          console.log(error);
        });
      } else {
        // if we have a failure, we need to empty the list
        select.emptyList();
        failure(term);
      }
    }
  
    function parse(data) {
      var parsed = [];
      var rows = data.split("\n");
      for ( var i = 0; i < rows.length; i++) {
        var row = rows[i].trim();
        if (row) {
          row = row.split("|");
          parsed[parsed.length] = {
            data :row,
            value :row[0],
            result :options.formatResult && options.formatResult(row, row[0]) || row[0]
          };
        }
      }
      return parsed;
    }
  
    function stopLoading() {
      input.classList.remove(options.loadingClass);
      input.setAttribute("aria-busy", "false");
    }
  }

  AutocompleteSelect(options, input, select, config) {
    const CLASSES = {
      ACTIVE: "ac_over",
      EVEN: "ac_even",
      ODD: "ac_odd",
      FIRST: "ac_first",
      LAST: "ac_last",
      MORE: "ac_more",
      DATA: "ac_data"
    };
  
    var listItems,
        active = -1,
        data,
        dataFiltered = [], // Filtered data for return/enter function usage
        term = "",
        needsInit = true,
        element,
        list;
  
    // Create results
    function init() {
      if (!needsInit)
        return;
  
      let listWidth = "";
      if (options.width > 0) {
        listWidth = "; width: " + options.width + "px";
      }
      document.body.insertAdjacentHTML("beforeend", `
        <div class="${options.resultsClass} ac_${options.typeString}" style='display: none; position: absolute${listWidth}'>
          <ul id="ac_results-${options.typeString}" role="listbox" aria-label="Autocomplete list">
          </ul>
        </div>
      `);
      element = document.querySelector(`#ac_results-${options.typeString}`).parentElement;
      list = document.querySelector(`#ac_results-${options.typeString}`);
  
  
      list.addEventListener("mouseover", function(event) {
        const elm = target(event);
        if (elm.nodeName && elm.nodeName.toUpperCase() == 'LI') {
          list.querySelectorAll("li").forEach(elm => {
            elm.classList.remove(CLASSES.ACTIVE);
            elm.setAttribute("aria-selected", "false");
          });
          active = [...elm.parentNode.children].indexOf(elm);
          elm.classList.add(CLASSES.ACTIVE);
  
          input.setAttribute("aria-activedescendant", elm.getAttribute("id"));
          elm.setAttribute("aria-selected", "true");
        }
      });
      list.addEventListener("click", function(event) {
        const elm = target(event);
        elm.classList.add(CLASSES.ACTIVE);
        input.setAttribute("aria-activedescendant", elm.getAttribute("id"));
        elm.setAttribute("aria-selected", "true");
        select();
        input.focus();
        return false;
      });
      list.addEventListener("mousedown", function(event) {
        config.mouseDownOnSelect = true;
      });
      list.addEventListener("mouseup", function() {
        config.mouseDownOnSelect = false;
      });
  
      needsInit = false;
    }
  
    function target(event) {
      var element = event.target;
      while (element && element.tagName != "LI")
        element = element.parentNode;
      // sometimes event.target is empty, just ignore it then
      if (!element)
        return [];
      return element;
    }
  
    function moveSelect(step) {
      var listItemsArr = [...listItems];
  
      var prevActiveItem = listItemsArr.slice(active, active + 1)[0];
      if(prevActiveItem) {
        prevActiveItem.classList.remove(CLASSES.ACTIVE);
        prevActiveItem.setAttribute("aria-selected", "false");
      }
  
      movePosition(step);
      
      var activeItem = listItemsArr.slice(active, active + 1)[0];
      activeItem.classList.add(CLASSES.ACTIVE)
      activeItem.setAttribute("aria-selected", "true");
  
      input.setAttribute("aria-activedescendant", activeItem.getAttribute("id"));
  
      if (options.scroll && (listItems.length > options.resultsBeforeScroll || options.resultsBeforeScroll == 0)) {
        var offset = 0;
        listItemsArr.slice(0, active).forEach(elm => {
          offset += elm.offsetHeight;
        });
        if ((offset + activeItem.offsetHeight - list.scrollTop) > list.clientHeight) {
          list.scrollTop = offset + activeItem.offsetHeight - list.clientHeight;
        } else if (offset < list.scrollTop) {
          list.scrollTop = offset;
        }
      }
    }
  
    function statusMsg(inputField, listItems) {
      var form = inputField.closest("form");
      var formFieldset = form.querySelector("fieldset");
      if(formFieldset) {
        form = formFieldset;
      }
      if(document.querySelector("html[lang='en']") != null) {
        var statusMsg = (listItems.length <= 0 ? "No results" : (listItems.length + (listItems.length > 1 ? " results are" : " result is") + " available, use up and down arrow keys to navigate."));
      } else {
        var statusMsg = (listItems.length <= 0 ? "Ingen resultater" : (listItems.length + (listItems.length > 1 ? " resultater" : " resultat") + " er tilgjengelig, bruk opp og ned piltaster for å navigere."));
      }
  
      var statusElem = form.querySelector(".ui-helper-hidden-accessible");
      if(statusElem) {
        statusElem.innerText = statusMsg;
      } else {
        form.insertAdjacentHTML("afterbegin", `
          <span role="status" aria-live="polite" class="ui-helper-hidden-accessible">
            ${statusMsg}
          </span>
        `)
      }
    }
  
    function movePosition(step) {
      active += step;
  
      var realLength = listItems.length - 1;
      if (active < 0) {
        active = !options.finiteScroll ? realLength : 0;
      } else if (active > realLength) {
        active = !options.finiteScroll ? 0 : realLength;
      }
    }
  
    function limitNumberOfItems(available) {
      return options.max && options.max < available ? options.max : available;
    }
  
    function addLi(formatted, cls, dt) {
      const formattedTerm = options.highlight(formatted, term);
      const id = "ac_results-" + options.typeString + "-" + formattedTerm.replace(/[^a-zA-Z0-9]/igm, "-");
      
      list.insertAdjacentHTML("beforeend", `
        <li id="${id}" class="${cls}" role="option" tabindex="-1" aria-selected="false">
          ${formattedTerm}
        </li>
      `);
      var li = document.querySelector("#" + id);
  
      dataFiltered.push(dt); // instead of $.data()
    }
  
    function addCls(i, max) {
      return ((i % 2 == 0) ? CLASSES.EVEN : CLASSES.ODD)
            + ((i == (max - 1)) ? " " + CLASSES.LAST : "")
            + ((i == 0) ? " " + CLASSES.FIRST : "");
    }
  
    function fillList() {
      list.innerHTML = "";
      var len = data.length;
      var max = limitNumberOfItems(len);
  
      var offset = 0;
      if(len > 0) {
        var j = len - 1;
        var formattedMoreLink = options.formatItem(data[j].data, j + 1, max, data[j].value, term, len);
        if(/^###MORE###LINK###.*$/.test(formattedMoreLink)) {
          formattedMoreLink = formattedMoreLink.replace(/^###MORE###LINK###[\s]*/, "");
          var dataMoreLink = data[j];
          var offset = 1;
        } else {
          formattedMoreLink = null;
        }
      }
  
      if(options.rank) {
        data = options.rank(data);
      }
  
      dataFiltered = []; // Clear
  
      for ( var i = 0; i < (max-offset); i++) {
        if (!data[i])
            continue;
  
        var formatted = options.formatItem(data[i].data, i + 1, max, data[i].value, term, len);
        if (formatted === false)
          continue;
  
        addLi(formatted, addCls(i, max), data[i]);
      }
  
      if(formattedMoreLink != null) {
        addLi(formattedMoreLink, addCls(max-offset, max) + " " + CLASSES.MORE, dataMoreLink);
      }
  
      listItems = list.querySelectorAll("li");
      
      if (options.selectFirst) {
        listItems[0].classList.add(CLASSES.ACTIVE);
        active = 0;
      } else {
        active = -1;
      }
    }
  
    return {
      display : function(d, q) {
        init();
        data = d;
        term = q;
        fillList();
      },
      next: function() {
        moveSelect(1);
      },
      prev: function() {
        moveSelect(-1);
      },
      pageUp: function() {
        if (active != 0 && active - 8 < 0) {
          moveSelect(-active);
        } else {
          moveSelect(-8);
        }
      },
      pageDown: function() {
        if (active != listItems.length - 1 && active + 8 > listItems.length) {
          moveSelect(listItems.length - 1 - active);
        } else {
          moveSelect(8);
        }
      },
      hide: function() {
        if(element) {
          element.style.display = "none";
        }
        if(listItems) {
          [...listItems].filter(elm => elm.classList.contains(CLASSES.ACTIVE)).forEach(elm => {
            elm.classList.remove(CLASSES.ACTIVE);
            elm.setAttribute("aria-selected", "false");
          });
          input.removeAttribute("aria-activedescendant");
        }
        active = -1;
        statusMsg(input, []);
      },
      visible: function() {
        return element && !(element.offsetParent === null);
      },
      show: function() {
        // Credits: https://usefulangle.com/post/179/jquery-offset-vanilla-javascript
        var rect = input.getBoundingClientRect();
        var offset = { 
                       top: rect.top + window.scrollY, 
                       left: rect.left + window.scrollX, 
                     };
  
        if(typeof options.width == "string" || options.width > 0) {
          var acWidth = (typeof options.width == "string") ? parseInt(options.width) : options.width;
        } else {
          var acWidth = input.offsetWidth;
        }
        if(options.minWidth && acWidth < options.minWidth) {
          acWidth = options.minWidth;
        }
        if(options.adjustForParentWidth) {
          acWidth += options.adjustForParentWidth;
        }
  
        element.style.width = acWidth + "px";
        element.style.top = (offset.top + input.offsetHeight) + "px";
        element.style.left = (offset.left + options.adjustLeft) + "px";
        element.style.display = "block";
  
        statusMsg(input, listItems);
  
        if (options.scroll && (listItems.length > options.resultsBeforeScroll || options.resultsBeforeScroll == 0)) {
          list.scrollTop = 0;
          list.style.maxHeight = options.scrollHeight + "px";
          list.style.overflow = "auto";
  
        } else {
          list.style.maxHeight = "100%";
          list.style.overflow = "hidden";
        }
        },
        selected : function() {
          if(listItems) {
            var selected = [...listItems].filter(elm => elm.classList.contains(CLASSES.ACTIVE));
            if(selected.length) {
              selected[0].classList.remove(CLASSES.ACTIVE);
              selected[0].setAttribute("aria-selected", "false");
              input.removeAttribute("aria-activedescendant");
            }
          }
          return selected && selected.length && dataFiltered[active];
        },
        emptyList : function() {
          if(list) {
            list.innerHTML = "";
          }
        },
        unbind : function() {
          element && element.remove();
        }
    };
  }

  // Cache term/data pairs, the extra code is for initial/local JSON-data (when not from URL)
  AutocompleteCache(options) {
    var data = {};
    var length = 0;
  
    function add(q, value) {
      if (length > options.cacheLength) {
        flush();
      }
      if (!data[q]) {
        length++;
      }
      data[q] = value;
    }
  
    // Local data
    function populate() {
      if (!options.data)
        return false;
      // track the matches
      var stMatchSets = {}, nullData = 0;
      // no url was specified, we need to adjust the cache length to make sure
      // it fits the local data store
      if (!options.url)
        options.cacheLength = 1;
      // track all options for minChars = 0
      stMatchSets[""] = [];
      // loop through the array and create a lookup structure
      for ( var i = 0, ol = options.data.length; i < ol; i++) {
        var rawValue = options.data[i];
        // if rawValue is a string, make an array otherwise just reference the array
        rawValue = (typeof rawValue == "string") ? [ rawValue ] : rawValue;
  
        var value = options.formatMatch(rawValue, i + 1, options.data.length);
        if (value === false)
          continue;
  
        var firstChar = value.charAt(0).toLowerCase();
        // if no lookup array for this character exists, look it up now
        if (!stMatchSets[firstChar])
          stMatchSets[firstChar] = [];
  
        // if the match is a string
        var row = {
          value: value,
          data: rawValue,
          result: options.formatResult && options.formatResult(rawValue) || value
        };
        stMatchSets[firstChar].push(row); // push the current match into the set list
        if (nullData++ < options.max) { // keep track of minChars zero items
          stMatchSets[""].push(row);
        }
      }

      for (const [key, value] of Object.entries(stMatchSets)) {
        options.cacheLength++; // increase the cache size
        add(key, value); // add to the cache
      }
    }
    function matchSubset(s, sub) {
      if (!options.matchCase)
        s = s.toLowerCase();
      var i = s.indexOf(sub);
      if (i == -1)
        return false;
      return i == 0 || options.matchContains;
    }
    // populate any existing data
    setTimeout(populate, 25);
  
    function flush() {
      data = {};
      length = 0;
    }
  
    return {
      flush: flush,
      add: add,
      populate: populate,
      load: function(q) {
        if (!options.cacheLength || !length)
          return null;
        /*
          * if dealing w/local data and matchContains than we must make sure to
          * loop through all the data collections looking for matches
          */
        if (!options.url && options.matchContains) {
          var csub = []; // track all matches
          for ( var k in data) { // loop through all the data grids for matches
            // don't search through the stMatchSets[""] (minChars: 0) cache
            // this prevents duplicates
            if (k.length > 0) {
              var c = data[k];
              c.forEach(x => {
                if (matchSubset(x.value, q)) { // if we've got a match, add it to the array
                  csub.push(x);
                }
              });
            }
          }
          return csub;
        } else if (data[q]) { // if the exact item exists, use it
          return data[q];
        } else if (options.matchSubset) {
          for ( var i = q.length - 1; i >= options.minChars; i--) {
            var c = data[q.substr(0, i)];
            if (c) {
              var csub = [];
              c.forEach(x => {
                if (matchSubset(x.value, q)) {
                  csub[csub.length] = x;
                }
              });
              return csub;
            }
          }
        }
        return null;
      }
    };
  }
}
export default Autocomplete;

/*
 * Extensions added by USIT for Vortex (2018 and earlier)
 *
 * [REMOVED, space selection key] [???. ????] Added RIGHTARROW & SPACE as selection keys
 * [???. ????] Added option "resultsBeforeScroll" (defines minimum nr of hits before scrollbar is added to dropdown)
 * [REMOVED] [???. ????] Added class when submit is blocked in FF for use externally (removed when intercepted in reroute-function in admin-enhancements and toggled off and does not interfere with anything else)
 * [???. ????] Added option "adjustForParentWidth"
 * [???. ????] Added option "min-width"
 * [REMOVED] [???. ????] Added class "ac_active_parent" for active autocomplete field (to solve stacking issues with multiple fields)
 * [REMOVED, autogenerated] [Oct. 2013] Added option "wrapperClass" possibility to distinguish between different autocomplete results
 * [Oct. 2013] Added class "ac_more" for special case in result when more-link is needed (if formatted starts with "###MORE###LINK###")
 * [Oct. 2013] Added option "finiteScroll" for not scrolling to top from bottom and vice versa on key/page up and down (set default to true)
 * [Oct. 2013] Added string constants to CLASSES object-literal for all CSS classes inside $.Autocompleter.Select
 * [Oct. 2013] Added option "updateInput" to make it possible to disable updating of input field on select (set default to true)
 * [Mar. 2014] Added ARIA status message and busy attribute to autocomplete field when loading
 * [Jun. 2017] Added possibility to rank autocomplete results with options.rank(data) that runs in fillList()
 * [Jun. 2017] Added total data length to options.formatItem() as last parameter (will not affect any existing code)
 * [Oct. 2018] Added option "autocompleteTemplate" which gives the possibility to use different templates than default (e.g. to use template for image filter)
 */